import React from 'react'
import { Heading } from '../HeadingModule/Heading'

interface FAQHeadingProps {
  text: string
}

export const FAQHeading = ({ text }: FAQHeadingProps) => {
  return <Heading text={text} as="h2" className="faq-section__heading" />
}
